module.exports = __webpack_public_path__ + "img/telltomm.4c005fd6.svg";